<template>
  <v-layout
    @dragleave.prevent="dragOut"
    @dragenter.prevent="dragIn"
    @dragover.prevent
    @drop.prevent="onDrop"
    @click="selectFile"
  >
    <label class="label" style="pointer-events: none">
      <template v-if="loading">
        <v-btn large loading flat block style="pointer-events: none" />
      </template>
      <template v-else>
        <template v-if="!dragging">
          <slot>ここに画像ファイルをドラッグ</slot>
        </template>
        <template v-else>
          <slot name="drag">ここに画像ファイルをドロップ</slot>
        </template>
        <input
          ref="input"
          @change="onDrop"
          :style="{ display: 'none' }"
          type="file"
          multiple
        />
      </template>
      <div v-if="message !== ''" style="height: 0.2rem" />
      <div v-if="message !== ''" style="font-size: 0.8rem; color: #aaa">
        {{ message }}
      </div>
    </label>
  </v-layout>
</template>

<script>
export const mimeTypes = {
  image: {
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
  },
  csv: {
    txt: 'text/plain',
    csv: 'text/csv',
    winCsvWithoutExcel: 'application/octet-stream',
    winCsvWithNewExcel: 'application/vnd.ms-excel',
    winCsvWithOldExcel:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  document: {
    dox: 'application/msword',
    docx:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    html: 'text/html',
    xml: 'text/xml',
    pdf: 'application/pdf',
    tsv: 'text/tab-separated-values',
  },
  multiple: {
    zip: 'application/zip',
    gz: 'application/gzip',
    xZipCompressed: 'application/x-zip-compressed',
  },
}

export default {
  name: 'AppFileDropArea',
  props: {
    mimeTypes: {
      type: [Array, Function],
      default: () => [
        mimeTypes.image.jpeg,
        mimeTypes.image.png,
        mimeTypes.image.gif,
      ],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dragging: false,
      counter: 0,
    }
  },
  methods: {
    selectFile() {
      this.$refs.input.addEventListener('click', e => {
        e.target.value = ''
      })
      this.$refs.input.click()
    },
    dragIn() {
      if (this.loading) {
        this.$confirm('画像圧縮中です', {
          body: `画像圧縮が終わってから画像をドロップしてください`,
          onlyOk: true,
        })
        return false
      }
      this.dragging = true
      this.counter++
      this.$emit('dragIn')
    },
    dragOut() {
      this.counter--
      if (this.counter === 0) {
        this.dragging = false
        this.$emit('dragOut')
      }
    },
    onDrop(event) {
      this.dragging = false
      this.counter = 0
      this.$emit('drop')
      const files = event.target.files
        ? event.target.files
        : event.dataTransfer.files
      if (files.length === 0) return
      const allowedFiles = Array.from(files).filter(file =>
        this.mimeTypes.includes(file.type),
      )
      if (allowedFiles.length === 0)
        throw new Error('許可されていないファイルタイプです。')
      this.$emit('files', allowedFiles)
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
